import { Point } from '../types/point'

export const getArrayPoints = (points: Point[]) =>
  points.map((point) => [point.geolocation.lat, point.geolocation.lng])
